import { v4 as uuidv4 } from 'uuid';

const ACCOUNT_ID_KEY = 'btp_account_id';
const ACCESS_TOKEN_KEY = 'btp_access_token';
const REFRESH_TOKEN_KEY = 'btp_refresh_token';
const LP_KEY = 'btp_legal_person_id';

export function getOrCreateAccountId() {
  let id = localStorage.getItem(ACCOUNT_ID_KEY);
  if (!id) {
    id = `m_${uuidv4().replace(/-/g, '')}`;
    localStorage.setItem(ACCOUNT_ID_KEY, id);
  }
  return id;
}

export function setAccountId(id) {
  if (id) localStorage.setItem(ACCOUNT_ID_KEY, String(id).trim());
}

export function getAccountId() {
  return localStorage.getItem(ACCOUNT_ID_KEY);
}

export function saveTokens(accessToken, refreshToken) {
  if (accessToken) localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  if (refreshToken) localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

export function clearSession() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
}

export function saveLegalPersonId(lpId) {
  if (lpId) localStorage.setItem(LP_KEY, lpId);
}

export function getLegalPersonId() {
  return localStorage.getItem(LP_KEY);
}

export function resolveLegalPersonFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const lp = params.get('lp') || params.get('legalPerson');
  if (lp) {
    saveLegalPersonId(lp.replace(/^legalPerson_/, '').trim());
    return lp.replace(/^legalPerson_/, '').trim();
  }
  return getLegalPersonId();
}
